import { LineStyle } from 'lightweight-charts';

const LINE_STYLE_ITEMS = [
  { label: 'Solid', style: LineStyle.Solid, dash: '' },
  { label: 'Dashed', style: LineStyle.Dashed, dash: '4 3' },
  { label: 'Dotted', style: LineStyle.Dotted, dash: '2 3' },
];

const TrendlinePopup = ({ selectedTL, containerWidth, onColorChange, onLineStyleChange, onRemove, onShowStyles, showStyleOptions, onClose }) => {
  if (!selectedTL) return null;

  const popupLeft = Math.min(selectedTL.x + 10, (containerWidth || 800) - 160);
  const popupTop = Math.min(selectedTL.y + 10, 430);

  return (
    <div className="tl-popup" style={{ left: popupLeft, top: popupTop }}>
      <input
        type="color"
        value={selectedTL.color}
        onChange={e => onColorChange(e.target.value)}
        className="tl-popup-color"
        title="Trend Line Color"
      />
      <div className="tl-popup-styles">
        {showStyleOptions ? (
          LINE_STYLE_ITEMS.map(({ label, style, dash }) => (
            <button
              key={label}
              className={`tl-popup-btn${selectedTL.lineStyle === style ? ' active' : ''}`}
              onClick={() => { onLineStyleChange(style); onClose(); }}
              title={label}
            >
              <svg width="16" height="6" viewBox="0 0 16 6">
                <line x1="0" y1="3" x2="16" y2="3" stroke="currentColor" strokeWidth="2"
                  {...(dash ? { strokeDasharray: dash } : {})} />
              </svg>
            </button>
          ))
        ) : (
          (() => {
            const cur = LINE_STYLE_ITEMS.find(i => i.style === selectedTL.lineStyle) || LINE_STYLE_ITEMS[0];
            return (
              <button
                className="tl-popup-btn active"
                onClick={onShowStyles}
                title={cur.label}
              >
                <svg width="16" height="6" viewBox="0 0 16 6">
                  <line x1="0" y1="3" x2="16" y2="3" stroke="currentColor" strokeWidth="2"
                    {...(cur.dash ? { strokeDasharray: cur.dash } : {})} />
                </svg>
              </button>
            );
          })()
        )}
      </div>
      <div className="tl-popup-separator" />
      <button
        className="tl-popup-btn tl-popup-remove"
        onClick={onRemove}
        title="Remove Trend Line"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <line x1="1" y1="1" x2="13" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <line x1="13" y1="1" x2="1" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
    </div>
  );
};

export default TrendlinePopup;
